import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getPackages, createPackage, updatePackage, deletePackage } from "./packages.service";

const QUERY_KEY = "packages";

export const useGetPackages = (params) => {
  return useQuery({
    queryFn: () => getPackages(params),
    queryKey: [QUERY_KEY, params],
    enabled: !!params?.vehicleId,
  })
}

export const useCreatePackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createPackage(data),
    onSuccess: () => {
      // Invalidate packages query to refetch updated list after creating a package
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    }
  });
}

export const useUpdatePackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ packageId, data }) => updatePackage(packageId, data),
    onSuccess: () => {
      // Invalidate packages query to refetch updated list after updating a package
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    }
  });
}

export const useDeletePackage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({packageId}) => deletePackage(packageId),
    onSuccess: () => {
      // Invalidate packages query to refetch updated list after deleting a package
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    }
  });
}